var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdm-stripe',{attrs:{"text":_vm.$t('novelty'),"size":_vm.size,"color":"#C4A181"}})}
var staticRenderFns = []

export { render, staticRenderFns }